import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ChevronLeft = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.3925 20.0026C15.2325 20.0026 15.0725 19.9326 14.9525 19.8026L8.1725 12.4526C7.9425 12.2026 7.9425 11.8126 8.1725 11.5626L14.9625 4.19257C15.2025 3.94257 15.5825 3.93257 15.8225 4.18257C16.0625 4.43257 16.0725 4.83257 15.8325 5.09257L9.4625 12.0026L15.8325 18.9126C16.0625 19.1626 16.0625 19.5726 15.8225 19.8226C15.7025 19.9426 15.5525 20.0026 15.4025 20.0026H15.3925Z" />
  </svg>
)

export default withDefaultStyles(ChevronLeft)
